import { decodeJwt } from './accessRight';
import { getStorage } from './localstorage';

const normalizeAccessValue = (value) => String(value || '').trim().toLowerCase();

export const isCaseManagementFlagEnabled = () =>
  process.env.REACT_APP_ENABLE_CASE_MANAGEMENT === 'true'
  || (process.env.NODE_ENV === 'development'
    && process.env.REACT_APP_ENABLE_CASE_MANAGEMENT !== 'false');

export const getCaseManagementAllowedUsers = () =>
  String(process.env.REACT_APP_CASE_MANAGEMENT_ALLOWED_USERS || '')
    .split(',')
    .map(normalizeAccessValue)
    .filter(Boolean);

export const getCurrentCaseManagementUserKeys = () => {
  const token = getStorage('token');
  if (!token) {
    return [];
  }

  try {
    const decoded = decodeJwt(token);
    return [
      decoded?.EMAIL,
      decoded?.email,
      decoded?.ONE_ID,
      decoded?.one_id,
      decoded?.ONEID,
    ]
      .map(normalizeAccessValue)
      .filter(Boolean);
  } catch (error) {
    return [];
  }
};

export const isCurrentUserAllowedForCaseManagement = () => {
  const allowedUsers = getCaseManagementAllowedUsers();
  if (!allowedUsers.length) {
    return false;
  }

  const currentUserKeys = getCurrentCaseManagementUserKeys();
  return currentUserKeys.some((key) => allowedUsers.includes(key));
};

export const canAccessCaseManagement = () =>
  isCaseManagementFlagEnabled() || isCurrentUserAllowedForCaseManagement();

export const shouldShowCaseManagementMenu = () => isCaseManagementFlagEnabled();
